<template>
  <div class="table-handle-result">
    <header>
      <p class="title-header"><span
          style="font-weight: bold;">{{ history?.metric_label }} #{{ history?.issue_id }} | Hệ thống</span> đã tổng hợp kết
        quả sau xử lý</p>
      <p class="title-time">{{history?.created_at}}</p>
    </header>
    <section class="row mt-5">
      <p class="col-lg-3">Khoảng thời gian đo lường::</p>
      <p class="col-lg-9">Từ {{ history?.measurement_range_from }} đến {{ history?.measurement_range_to }}</p>
      <p class="col-lg-3">Mục tiêu:</p>
      <p class="col-lg-9">{{ history?.target_percent }}%</p>
      <p class="col-lg-3">Thời gian nhận kết quả:</p>
      <p class="col-lg-9">{{ history?.result_at }}</p>
      <p class="col-lg-3">Kết quả đo lường:</p>
      <p class="col-lg-9">{{ history?.actual_percent?`${history?.actual_percent}%`:'' }}</p>
    </section>

  </div>
</template>
<script>
export default {
  name: "MeasurementResults",
  props: {
    history: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style scoped>
.table-handle-result {
  width: 100%;
  border: 1px solid #929292;
  padding: 10px;
  background-color: white;
}

.title-header {
  color: #4C0192;
}

.title-time {

}

header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #929292;
}

</style>